import HttpMethod from '@/consts/httpMethod';
import { processRequest, processSuccessResponse, processErrorResponse } from '@/helpers';

export default {
  async getClientByPhoneNumber(phoneNumber) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `v2/clients/phone-${phoneNumber}/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, {});
      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getClientByCitizenId(citizenId) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `v2/clients/citizen-${citizenId}/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, {});
      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getClientById(id) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `v2/clients/${id}/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, {});
      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async createClient(data) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: 'v2/clients/',
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, { data });
      const client = processSuccessResponse(res);

      return client;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async updateClient(id, data) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `v2/clients/${id}/`,
      method: HttpMethod.PUT
    };

    try {
      const res = await processRequest(ep, { data });
      const client = processSuccessResponse(res);

      return client;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  }
};
